package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.ModelPreview
import top.wcpe.allincore.ui.runtime.element.UIElement

/** 将独立模型预览元素委托给平台桥。 */
class ModelPreviewRenderer : Renderer {

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        val preview = element as? ModelPreview ?: return
        bridge.drawModelPreview(
            preview.source(),
            preview.modelBase(),
            preview.texture(),
            preview.instanceKey(),
            box.x(),
            box.y(),
            box.width(),
            box.height(),
            preview.scale(),
            preview.rotationX(),
            preview.rotationY(),
            preview.interactive(),
            preview.backgroundColor(),
        )
    }
}
